import createStore from './store';
import { ClipVersion } from '@/Pages/Clip/ClipPlayer/ClipCustomizer/ClipCustomizerVersioningPanel/types';

interface ClipVersionState {
  versions: ClipVersion[];
  viewingVersion: ClipVersion | null;
}

const initialState: ClipVersionState = {
  versions: [],
  viewingVersion: null
};

const store = createStore<ClipVersionState>(initialState);

export const clipVersionStore = {
  ...store,
  setVersions: (versions: ClipVersion[]) =>
    store.update(draft => {
      draft.versions = versions;
    }),
  setViewingVersion: (version: ClipVersion | null) =>
    store.update(draft => {
      draft.viewingVersion = version;
    }),
  reset: () => store.set(() => initialState)
};
